require('bootstrap');
require('bootstrap/dist/css/bootstrap.min.css');
require('@fortawesome/fontawesome-free/css/all.min.css');
require("animate.css/animate.css");
require('./assets/css/style.css');

import Vue from 'vue';
import App from './App';
import router from './router';
import i18n from './i18n';
import VueAnalytics from 'vue-analytics';

// Anime.js
import animejs from './assets/libraries/animejs/anime.js';

// Slick Carousel
require('slick-carousel/slick/slick.css');
require('slick-carousel/slick/slick-theme.css');
require('slick-carousel/slick/slick.min.js');

// Carousel3d
import Carousel3d from 'vue-carousel-3d';
Vue.use(Carousel3d);

Vue.config.productionTip = false;

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
window.$ = window.jQuery = require('jquery');

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios');
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';


/* eslint-disable no-new */
new Vue({
    el: '#app',
    router: router,
    i18n: i18n,
    components: { App },
    template: '<App/>',

    data: {
        animejs: animejs,
        menuitems: [],
        auth: {
            auth: {
                username: 'api_user',
                password: 'pwd4Epi.'
            }
        },
        keyparticles: 0,
        keyApplication: 0,

        routerViewAnimateEnter: '',
        routerViewAnimateLeave: '',

        idObject: null
    },

    created() {
        axios.get('https://www.biswiss.ch/backend/api/menu_items/main', this.$root.auth)
        .then(response => {
            var routes = [];

            $.each(response.data, function(index, value) {
                var name = value.options.attributes['vue-route-name'];
                routes.push({
                    path: '/' + (name == 'home' ? '' : name),
                    name: name,
                    component: require("./components/pages/" + value.options.attributes['vue-component']).default,
                    meta: {title: value.title, api: value.absolute, bgeffect: value.options.attributes['bg-effect']},
                });
            });

            this.$router.addRoutes(routes);
            this.menuitems = routes;
        });
    },

    methods: {
        setTransitionRouterView(newRoute) {
            var oldRoute = this.$route.name;
            var indexOld = 0;
            var indexNew = 0;
            $.each(this.menuitems, function(index, value) {
                if(value.name == oldRoute) {
                    indexOld = index;
                }

                if(value.name == newRoute) {
                    indexNew = index;
                }
            });

            if(newRoute !== "case-studies" && newRoute !== "ambiti" && newRoute != "contatti") {
                this.routerViewAnimateEnter = indexOld < indexNew ? 'animate__animated animate__fadeInUpBig' : 'animate__animated animate__fadeInDownBig';
                this.routerViewAnimateLeave = indexOld < indexNew ? 'animate__animated animate__fadeOutUpBig' : 'animate__animated animate__fadeOutDownBig';
            }
            else {
                this.routerViewAnimateEnter = '';
                this.routerViewAnimateLeave = indexOld < indexNew ? 'animate__animated animate__fadeOutUpBig' : 'animate__animated animate__fadeOutDownBig';
            }
        },

        resetTransitionRouterView() {
            this.routerViewAnimateEnter = '';
            this.routerViewAnimateLeave = '';
        },

        changeRouteView() {
            this.keyparticles += 1;
        },

        getLanguage() {
            return i18n.locale;
        },

        clickLink(newRoute) {
            this.setTransitionRouterView(newRoute);
            this.$router.push({name: newRoute});
            this.changeRouteView();
        },

        getClassSize() {
            var winWidth =  $(window).width();
            if(winWidth < 544) {
                return "";
            }
            else if(winWidth >= 544 && winWidth < 768) {
                return "sm";
            }
            else if(winWidth >= 768 && winWidth < 992) {
                return "md";
            }
            else if(winWidth >= 992 && winWidth < 1200) {
                return "lg";
            }
            else if(winWidth >= 1200) {
                return "xl";
            }
        },

        /*getRoutesList(routes, pre) {
            return routes.reduce((array, route) => {
                const path = `${pre}${route.path}`;

                if (route.path !== '*') {
                    array.push(path);
                }

                if (route.children) {
                    array.push(this.getRoutesList(route.children, `${path}/`));
                }

                return array;
            }, []);
        },

        getRoutesXML() {
            const list = this.getRoutesList(this.menuitems, 'https://biswiss.ch')
                .map(route => `<url><loc>${route}</loc></url>`)
                .join('\r\n');
                return `<urlset xmlns="http://www.sitemaps.org/schemas/sitemap/0.9" xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xsi:schemaLocation="http://www.sitemaps.org/schemas/sitemap/0.9 http://www.sitemaps.org/schemas/sitemap/0.9/sitemap.xsd">
                ${list}
                </urlset>`;
        }*/
    }
});

Vue.use(VueAnalytics, { 
    id: 'UA-136431881-3', 
    router
});



// WEBPACK FOOTER //
// ./src/main.js